// extracted by mini-css-extract-plugin
module.exports = {"stack":"LabsLeading_stack__6Z_sL","circle":"LabsLeading_circle__YsiVl","image":"LabsLeading_image__WhM2f"};